import React from "react";
import Navbar from "../components/Navbar";

const AdminD = () => {
  return (
    <>
      <Navbar></Navbar>
      <h1 className="flex justify-center font-semibold">
        Dashboard is in developement currently. Come back later...
      </h1>
      <h3 className="flex justify-center font-semibold">Happy Saving</h3>
    </>
  );
};

export default AdminD;
